/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface IntegrationPersonRegisteredPersonIdGet$Params {

/**
 * Person identifier to check.
 */
  personId: string;
}

export function integrationPersonRegisteredPersonIdGet(http: HttpClient, rootUrl: string, params: IntegrationPersonRegisteredPersonIdGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, integrationPersonRegisteredPersonIdGet.PATH, 'get');
  if (params) {
    rb.path('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as WearablesStrictHttpResponse<boolean>;
    })
  );
}

integrationPersonRegisteredPersonIdGet.PATH = '/Integration/PersonRegistered/{personId}';
